import React from "react";
import { Edit } from "lucide-react";
import { infoToast } from "../../../../../services/toast.service";

const ProductSpecifications = ({ material, description }) => {
  // Combine static and dynamic specifications
  const specifications = [
    { key: "Material", value: material || "Not specified" },
    { key: "Upper Material", value: "Rexene Upper" },
    { key: "Sole Material", value: "PVC" },
    { key: "Inner Lining", value: "Mesh" },
    { key: "Weight", value: "250g" },
    { key: "Height", value: "10cm" },
    { key: "Width", value: "Standard" },
    { key: "Water Resistant", value: "Yes" },
    { key: "Anti-Slip", value: "Yes" },
    { key: "Arch Support", value: "Medium" },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-base font-semibold text-gray-800">
            Product Specifications
          </h2>
          <button
            className="text-[#5652B0] hover:bg-[#F9F8FE] p-1.5 rounded-md"
            onClick={() => infoToast("Edit not available in demo.")}>
            <Edit size={16} />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-y-3">
          {specifications.map((spec, index) => (
            <div key={index} className="flex items-center pr-4">
              <span className="text-gray-500 text-sm min-w-[120px]">
                {spec.key}:
              </span>
              <span className="text-gray-800 text-sm font-medium ml-2">
                {spec.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Product Description */}
      {description && (
        <div className="bg-white rounded-lg p-4 border border-gray-200">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-base font-semibold text-gray-800">
              Product Description
            </h2>
            <button
              className="text-[#5652B0] hover:bg-[#F9F8FE] p-1.5 rounded-md"
              onClick={() => infoToast("Edit not available in demo.")}>
              <Edit size={16} />
            </button>
          </div>

          <p className="text-gray-700 text-sm leading-relaxed">{description}</p>
        </div>
      )}
    </div>
  );
};

export default ProductSpecifications;
